/* eslint-disable @typescript-eslint/no-explicit-any */
import qs from "qs";
import { api } from "../api/httpClient";
import { buildUrl } from "../../utils/bindUrl";
import type {
  IResponseListRegions,
  IResponseShowRegion,
  IRegion,
} from "../../interfaces/regions";
import type { IListParams } from "@/interfaces/serviceInterface";

const BASE = "/regions";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

/** GET /regions */
export async function listRegions(params: Partial<IListParams> = {}): Promise<IResponseListRegions> {
  const { data } = await api.get<IResponseListRegions>(BASE, {
    params,
    paramsSerializer: serialize,
  });
  return data;
}

/** GET /regions/:id */
export async function showRegion(
  args: { id: string | number } & Partial<IListParams>
): Promise<IResponseShowRegion> {
  const { id, includes } = args;
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.get<IResponseShowRegion>(url, {
    params: { includes },
    paramsSerializer: serialize,
  });
  return data;
}

/** POST /regions  body: { region } */
export async function createRegion({ region }: { region: IRegion }): Promise<IResponseShowRegion> {
  const { data } = await api.post<IResponseShowRegion>(BASE, { region });
  return data;
}

/** PUT /regions/:id  body: { region } */
export async function updateRegion({
  id,
  region,
}: {
  id: string | number;
  region: IRegion;
}): Promise<IResponseShowRegion> {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.put<IResponseShowRegion>(url, { region });
  return data;
}

/** DELETE /regions/:id (opcional, se existir no backend) */
export async function deleteRegion(id: string | number): Promise<void> {
  const url = buildUrl(`${BASE}/{id}`, { id });
  await api.delete(url);
}
